// Token handed over in the `sr_handoff` cookie, captured by sr-token-handoff.v1.js
// (first script in public/index.html). Cookie token wins over ?token=; see bfrs/sr_login#4394.
declare global {
  interface Window {
    SRTokenHandoff?: { peek(): string | null; clear(): void };
  }
}

export function getCookieHandoffToken(): string | null {
  return window.SRTokenHandoff?.peek() ?? null;
}

export function clearHandoffToken(): void {
  window.SRTokenHandoff?.clear();
}
